import { z } from 'zod';
import { itemSchema } from './item/item-dto';
import { roadmapItemsMetadataSchema } from './roadmap-items-dto';

export const roadmapViewItemsResponseSchema = z.object({
  items: z.array(itemSchema),
  metadata: roadmapItemsMetadataSchema,
});

export type RoadmapViewItemsResponseDTO = z.infer<typeof roadmapViewItemsResponseSchema>;
